import React from 'react'
import PropTypes from 'prop-types'
import {FaIcon} from '../components'

export const GGCheckbox = ({
  label,
  checked,
  onChange,
  name,
  value = '1',
  disabled = false,
  className,
}) => {
  const classes = [
    'gg-checkbox',
    disabled && 'gg-checkbox--disabled',
    className,
  ].filter(Boolean).join(' ')

  return (
    <label className={classes}>
      <input
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={disabled ? undefined : (e) => onChange(e.target.checked)}
      />
      <span className="gg-checkbox__box" aria-hidden>
        <FaIcon icon="check"/>
      </span>
      {label && <span className="gg-checkbox__label">{label}</span>}
    </label>
  )
}

GGCheckbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}
